import { memo } from 'react';

import { cn } from '../../lib/styles';

interface SectionHeaderProps {
  title: string;
  className?: string;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
}

const SectionHeaderBase = ({ title, className, prefix, suffix }: SectionHeaderProps) => {
  return (
    <div className={cn('flex items-center flex-wrap gap-2 py-3 min-h-14', className)}>
      {prefix}

      <div className="font-body-lg capitalize font-semibold text-text-primary truncate dark:text-white">{title}</div>

      {suffix ? (
        <>
          <div className="flex-1 ml-2" />

          {suffix}
        </>
      ) : null}
    </div>
  );
};

export const SectionHeader = memo(SectionHeaderBase);
